/** ISO date `YYYY-MM-DD`. Tag "Novo" is visible through this day (inclusive). */
export type NewTagUntil = `${number}-${number}-${number}`;

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function parseDateOnly(value: string): Date | null {
  const match = ISO_DATE_PATTERN.exec(value);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/** Whether the "Novo" tag should render for `newUntil` on `referenceDate` (default: today). */
export function isNewTagVisible(
  newUntil: string | undefined,
  referenceDate: Date = new Date()
): boolean {
  if (!newUntil) {
    return false;
  }

  const until = parseDateOnly(newUntil);
  if (!until) {
    return false;
  }

  return startOfDay(referenceDate).getTime() <= until.getTime();
}
